import { Box, Divider, Flex, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import GiftBundles from "areas/cart/line-items/gift-wrap/gift-bundles"
// import GiftWraps from "areas/cart/line-items/gift-wrap/gift-wraps"
import { useAddonCart } from "contexts/addon-cart"

import { ProductTitle } from "../components"

// import GreetingCard from "./greeting-card"

const ImgWrapper = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.grey[20]};
  height: 88px;
  width: 88px;
  ${(props) => props.theme.mediaQueries.desktop`
    height: 190px;
    width: 190px;
  `}
`

const LineItem = ({
  line_item,
  handleGiftBundle,
  // handleGiftWrap,
  // handleGreetingCard,
}) => {
  const { addonItems } = useAddonCart()

  // const selectedGiftWrap = addonItems.find(
  //   ({ lid, addon_type }) => line_item.id === lid && addon_type === "PACKAGING"
  // )

  // const selectedGreetingCard = addonItems.find(
  //   ({ lid, addon_type }) =>
  //     line_item.id === lid && addon_type === "GREETING_CARD"
  // )
  const selectedGiftBundle = addonItems.find(
    ({ lid, addon_type }) =>
      line_item.id === lid && addon_type === "GIFT_BUNDLE"
  )

  return (
    <>
      <Box pb={{ _: 0, desktop: 6 }} pt={2}>
        <Flex
          flexDirection={{ _: "column", tablet: "row" }}
          gap={{ _: 4, tablet: 6 }}
        >
          <Box>
            <Flex gap="10px">
              <ImgWrapper>
                <Image alt={line_item.title} src={line_item.image_url} />
              </ImgWrapper>
              <ProductTitle
                display={{ desktop: "none" }}
                fontSize="16px"
                letterSpacing="-0.02em"
                width="146px"
              >
                {line_item.title}
              </ProductTitle>
            </Flex>
          </Box>
          <Box>
            <ProductTitle
              display={{ _: "none", desktop: "block" }}
              lineHeight="24px"
              mb={4}
            >
              {line_item.title}
            </ProductTitle>
            {/* {line_item.can_add_greeting_card && (
              <GreetingCard
                handleGreetingCard={(card, callbacks) =>
                  handleGreetingCard(line_item, card, callbacks)
                }
                item={line_item}
                selectedGreetingCard={selectedGreetingCard}
              />
            )}
            {line_item.can_add_gift_wrap && (
              <GiftWraps
                handleGiftWrap={(wrap) => handleGiftWrap(line_item, wrap)}
                item={line_item}
                itemWrap={selectedGiftWrap}
              />
            )} */}
            {line_item.can_add_gift_bundle && (
              <GiftBundles
                handleGiftBundle={(gift_bundle, callbacks) => {
                  handleGiftBundle(line_item, gift_bundle, callbacks)
                }}
                item={line_item}
                itemGiftBundle={selectedGiftBundle}
              />
            )}
          </Box>
        </Flex>
      </Box>
      <Divider bg="grey.20" my={2} />
    </>
  )
}

LineItem.propTypes = {
  handleGiftBundle: PropTypes.func,
  // handleGiftWrap: PropTypes.func,
  // handleGreetingCard: PropTypes.func,
  line_item: PropTypes.object,
}

export default LineItem
